module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/Barry-S2.3fc70ad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/Barry-S2.jpg
// module id = 0mE/
// module chunks = 0